import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { getFavorites, type FavoriteType, type FavoriteItem } from '@/lib/favorites'

const Section = ({ title, items }: { title: string; items: FavoriteItem[] }) => (
  <section className="mb-6">
    <h3 className="text-lg font-semibold mb-2">{title}</h3>
    {items.length === 0 ? (
      <p className="text-noe-400 text-sm">Nenhum favorito ainda.</p>
    ) : (
      <ul className="space-y-2">
        {items.map((it) => (
          <li key={it.id} className="flex items-center justify-between border border-noe-800 rounded p-3">
            <span>{it.title ?? 'Item'}</span>
            <Link to={it.url ?? '#'} className="text-sm text-noe-300 hover:text-noe-brand">Abrir</Link>
          </li>
        ))}
      </ul>
    )}
  </section>
)

const ProfileFavoritesPage = () => {
  const { user } = useAuth()
  const [data, setData] = useState<{ news: FavoriteItem[]; listing: FavoriteItem[]; group: FavoriteItem[] }>({ news: [], listing: [], group: [] })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) return
    getFavorites(user.uid).then((f) => {
      setData({ news: f.news ?? [], listing: f.listing ?? [], group: f.group ?? [] })
      setLoading(false)
    })
  }, [user])

  if (!user) {
    return <div className="p-4">Entre para ver seus favoritos.</div>
  }

  if (loading) return <div className="p-4">Carregando favoritos...</div>

  return (
    <div className="p-4 space-y-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold">Favoritos</h1>
       <Section title="Notícias salvas" items={data.news.map((n) => ({ id: n.id, itemId: n.itemId, type: 'news' as FavoriteType, title: n.title, url: `/news/${n.itemId}` }))} />
       <Section title="Anúncios salvos" items={data.listing.map((l) => ({ id: l.id, itemId: l.itemId, type: 'listing' as FavoriteType, title: l.title, url: `/listings/${l.itemId}` }))} />
       <Section title="Grupos salvos" items={data.group.map((g) => ({ id: g.id, itemId: g.itemId, type: 'group' as FavoriteType, title: g.title, url: `/groups/${g.itemId}` }))} />
    </div>
  )
}

export default ProfileFavoritesPage
